import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Fab, Tooltip } from '@mui/material';
import { MaterialIcon } from '../atoms/Icons';
var OfferListMaterialFab = function (_a) {
    var infoMaterialUrl = _a.offerList.infoMaterialUrl, _b = _a.blankValue, blankValue = _b === void 0 ? '' : _b, _c = _a.showTitle, showTitle = _c === void 0 ? false : _c;
    var t = useTranslation().t;
    var handleClick = function (e) {
        e.preventDefault();
        window.open(infoMaterialUrl, '_blank', 'noreferrer');
    };
    if (!infoMaterialUrl)
        return React.createElement(React.Fragment, null, blankValue);
    return (React.createElement(Tooltip, { title: t('labels.material') },
        React.createElement(Fab, { size: "small", variant: "outlinedExtended", onClick: handleClick },
            React.createElement(MaterialIcon, { sx: { width: 18, height: 18 } }),
            showTitle && (React.createElement(Box, { component: "span", sx: {
                    color: function (theme) { return theme.customPalette.text.primary; },
                    typography: function (theme) { return theme.customTypography.fab; },
                } }, t('labels.material'))))));
};
export default OfferListMaterialFab;
